<template>
  <!-- Liste des travaux: every constat across the units, filterable -->
  <v-layout>
    <d-header fluid>
      <h1 class="title">
        {{ $t("works_list") }}
      </h1>
    </d-header>

    <v-works-table
      show-property
      show-filters
      searchable
    />
  </v-layout>
</template>

<script>
import WorksTable from "../propertyInspection/components/WorksTable.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("works_list"),
    };
  },
  components: {
    "v-works-table": WorksTable,
  },
};
</script>
